import cssText from "bundle-text:./styles.css"; //Inlines the CSS for compatibility with shadow dom
import blissProWoff2 from 'url:./fonts/blisspro-webfont.woff2';
import blissProWoff from 'url:./fonts/blisspro-webfont.woff';
import images from "./images/*.jpg";
import swatches from "./images/swatches/*.svg";
import { rows } from "./rows";
import { dependencyMap } from "./dependencyMap";
import "web-dialog";

class SelectionGallery extends HTMLElement {
  static observedAttributes = ["styles"];

  attributeChangedCallback(name, _oldValue, newValue) {
    if (name === "styles") {
      if (this.shadowRoot.getElementById("custom-style")) {
        this.shadowRoot.getElementById("custom-style").remove();
      }
      let customStyle = document.createElement("style");
      customStyle.id = "custom-style";
      customStyle.textContent = newValue;
      this.shadowRoot.appendChild(customStyle);
    }
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.innerHTML = `
    <div class="container">
    <web-dialog class="dialog">
    <button class="closeButton">x</button>
      <div class="dialogBox">
      </div>
    </web-dialog>
    <div class="gallery-control">
      <div class="gallery">
      <img class="imageDisp"/>
        <div class="gallery-nav">
          <button class="left">
            <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2 0.00012207L13.5 2.50012L4.6 11.2001L13.5 20.0001L11.2 22.4001L0 11.2001L11.2 0.00012207Z" fill="white"/>
            </svg>
          </button>
          <button class="right">
            <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M2.8 0.00012207L0.5 2.50012L9.4 11.2001L0.5 20.0001L2.8 22.4001L14 11.2001L2.8 0.00012207Z" fill="white"/>
            </svg>
          </button>
        </div>
      </div>
      <div class="gallery-radios"></div>
    </div>
    <div class="nav-container">
      <div class="header">
      <div class="interior">Interior Design Configurator</div>
      <div class="selection">Make Your Selection Below</div>
       </div
    </div>
    </div>`;

    // inject <style> tag
    let style = document.createElement("style");
    style.textContent = cssText;
    this.shadowRoot.appendChild(style);

    const font = document.createElement('style');
    font.textContent = `
    @font-face {
      font-family: 'Bliss Pro';
      src: url('${blissProWoff2}') format('woff2'),
           url('${blissProWoff}') format('woff');
      font-weight: normal;
      font-style: normal;
    }
    `;

    document.head.appendChild(font);

    const hubspotScript = document.createElement('script');
    hubspotScript.src='https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(hubspotScript);

    this.touchStartX = 0;
    this.touchEndX = 0;

    this.container = this.shadowRoot.querySelector('.container'); // Assuming you've defined this in your constructor
    this.gallery = this.shadowRoot.querySelector(".gallery");
    this.image = this.shadowRoot.querySelector(".imageDisp");
    this.navButtons = this.shadowRoot.querySelector(".nav-container");
    this.galleryControl = this.shadowRoot.querySelector(".gallery-control");
    this.galleryRadios = this.shadowRoot.querySelector(".gallery-radios");
    this.rows = rows;
    this.selections = [];
    this.selectedImageIndex = 0;
    this.rowContainers = [];

    rows.forEach((row, rowIndex) => {
      const container = document.createElement("div");
      container.className = "option-group";

      // Create a title element for the row
      const title = document.createElement("span");
      title.textContent = row.rowTitle;
      title.className = "toggle-button";
      title.innerHTML = `${row.rowTitle}<svg class="triangle up" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Arrow">
      <path id="Polygon 1" d="M5.93898 6.7819C5.83929 6.89702 5.66071 6.89702 5.56102 6.7819L1.56161 2.16378C1.42139 2.00187 1.5364 1.75012 1.75059 1.75012L9.74941 1.75012C9.9636 1.75012 10.0786 2.00187 9.93839 2.16379L5.93898 6.7819Z" fill="#090304"/>
      </g>
      </svg>`;
      container.appendChild(title);

      const buttonContainer = document.createElement("div");
      buttonContainer.className = "buttonGroup";
      container.appendChild(buttonContainer);

      buttonContainer.style.display = "none";
      container.appendChild(buttonContainer);

      // Build the options for each row
      row.options.forEach((opt, optIndex) => {
        // Create a button element
        const button = document.createElement("div");
        button.className = "swatchText";
        button.innerHTML = `<img src='${swatches[opt.key]}') /> <span>${
          opt.key
        }</span>`;
        button.setAttribute('key', opt.key);

        button.addEventListener("click", () => {
          this.selections[rowIndex] = opt;
          this.checkDependencies();
          this.displayImage();
          
          // Remove selected class from all buttons in this group
          const allButtons = buttonContainer.querySelectorAll('.swatchText');
          allButtons.forEach(btn => btn.classList.remove('button-selected'));

          // Add selected class to the clicked button
          button.classList.add('button-selected');
        });

        if (optIndex === 0) {
          button.classList.add('button-selected');
          this.selections[rowIndex] = opt; // Ensure the first option is set as selected
        }

            buttonContainer.appendChild(button);
      });

      title.addEventListener("click", () => {
        const isHidden = buttonContainer.style.display === "none";
        buttonContainer.style.display = isHidden ? "flex" : "none";
        title.querySelector(".triangle").classList.toggle("down", isHidden);
        title.querySelector(".triangle").classList.toggle("up", !isHidden);
      });

      // Append the whole lot to the dom
      this.navButtons.appendChild(container);
      this.rowContainers.push(buttonContainer);
      this.checkDependencies();
    });

    this.checkDependencies();
    const confrimSelection = document.createElement("button");
    confrimSelection.textContent = "SUBMIT CONFIGURATION";
    confrimSelection.className = "confirmButton";
    confrimSelection.id = "confirm-selection";
    this.navButtons.appendChild(confrimSelection);
  }

  connectedCallback() {
    this.calculateGalleryButtons();
    this.displayImage();
    this.displayGalleryButtons();
    this.setupHandlers();
    this.setupTouchHandlers();
  }

  displayGalleryButtons() {
    const count = this.countImages;
    for(let index = 0; index < count; index++) {
      const radio = document.createElement("input");
      radio.type = "radio";
      radio.id = "image-selector-" + index;
      radio.name = this._name;
      radio.value = index;

      if (index === this.selectedImageIndex) {
        radio.checked = "checked";
      }

      this.galleryRadios.appendChild(radio);
    }
  }

  calculateGalleryButtons() {
    const path = buildImageBasePath(
      this.selections.map((selection) => selection.key)
    );
    const matchingItemsCount = Object.keys(images).filter((item) =>
      item.startsWith(path)
    ).length;
    this.countImages = matchingItemsCount;
  }

  setupTouchHandlers() {
    this.gallery.addEventListener("touchstart", (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    }, false);
  
    this.gallery.addEventListener("touchend", (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipeGesture();
    }, false);
  }

  handleSwipeGesture() {
    if (this.touchEndX < this.touchStartX) {
      // Swipe Left - Show next image
      if (this.selectedImageIndex < this.countImages - 1) {
        this.selectedImageIndex++;
      } else {
        this.selectedImageIndex = 0; // Optionally, wrap around to the first image
      }
    }
    if (this.touchEndX > this.touchStartX) {
      // Swipe Right - Show previous image
      if (this.selectedImageIndex > 0) {
        this.selectedImageIndex--;
      } else {
        this.selectedImageIndex = this.countImages - 1; // Optionally, wrap around to the last image
      }
    }
    this.updateRadioButtons();
    this.displayImage();
  }

  setupHandlers() {
    const button = this.shadowRoot.getElementById("confirm-selection");
    const leftButton = this.shadowRoot.querySelector(".left");
    const rightButton = this.shadowRoot.querySelector(".right");

    button.addEventListener("click", () => {
      this.handleSubmit();
    });
    
    leftButton.addEventListener("click", () => {
      if (this.selectedImageIndex > 0) {
        this.selectedImageIndex--;
      } else {
        this.selectedImageIndex = this.countImages - 1; // go to the last image
      }
      this.updateRadioButtons();
      this.displayImage();
    });

    rightButton.addEventListener("click", () => {
      if (this.selectedImageIndex < this.countImages - 1) {
        this.selectedImageIndex++;
      } else {
        this.selectedImageIndex = 0; // go back to the first image
      }
      this.updateRadioButtons();
      this.displayImage();
    });

    for(let index = 0; index < this.countImages; index++) {
      const radio = this.shadowRoot.getElementById("image-selector-" + index);
      radio.addEventListener("click", () => {
        this.selectedImageIndex = index;
        this.displayImage();
      });
    }
  }

  addImage(src) {
  
  // Show loading overlay
  this.container.classList.add('loadingCursor'); // Use if adding cursor loading animation

  this.image.onload = this.image.onerror = () => {
    // Hide loading overlay and reset cursor
    this.container.classList.remove('loadingCursor');
  };

    const img = document.createElement("img");
    img.src = images[src];
    this.image.src = images[src];
  }

  displayImage() {
    let imagePath;
    const keys = this.selections.map((selection) => selection.key);
    imagePath = buildImageSrc(keys, this.selectedImageIndex);
    if (imagePath === undefined) {
      imagePath = buildImageSrc(["default"]);
    }

    this.addImage(imagePath);
    // Prefetch the related images for selections
    (async() => {
      for(let index = 0; index < this.countImages; index++) {
        (new Image()).src = images[buildImageSrc(keys, index)];
      }
    })();
  }

  updateRadioButtons() {
    for (let index = 0; index < this.countImages; index++) {
      const radio = this.shadowRoot.getElementById("image-selector-" + index);
      radio.checked = index === this.selectedImageIndex;
    }
  }

  checkDependencies() {
    for(let rowIndex = 0; rowIndex < this.rows.length; rowIndex++) {
      this.ensureRowHasValidSelection(rowIndex);
      this.processValidRowChildren(rowIndex);
    }
  }

  processValidRowChildren(rowIndex) {
    const childRowIndex = rowIndex + 1;
    const subDependencyMap = this.getRowSelectionDependencyMap(childRowIndex);
    for (let i = 0; i < this.rowContainers[childRowIndex]?.children.length; i++) {
      const childElement = this.rowContainers[childRowIndex].children[i];
      //If it's not a valid child, don't let it be selected
      if (!subDependencyMap[childElement.getAttribute("key")]) {
        childElement.classList.add('button-unselectable');
      }
      else {
        childElement.classList.remove('button-unselectable');
      }

      // Process whether the child should be 'selected'
      if(this.selections[childRowIndex].key === childElement.getAttribute("key")) {
        childElement.classList.add('button-selected');
      } else {
        childElement.classList.remove('button-selected');
      }
    }
  }

  ensureRowHasValidSelection(rowIndex) {
    const subDependencyMap = this.getRowSelectionDependencyMap(rowIndex);
    const selectedItemKey=this.selections[rowIndex]?.key
    if (!this.selections[rowIndex] || !subDependencyMap[selectedItemKey]) {
      this.clearSelectionStyleFromRow(rowIndex);
      this.selections[rowIndex] = rows[rowIndex].options.find((option) => option.key === Object.keys(subDependencyMap)[0]);
      this.styleSelectedOptionInRow(rowIndex, this.selections[rowIndex].key);
    }
  }

  styleSelectedOptionInRow(rowIndex, key) {
    const row = this.rowContainers[rowIndex];
    if(!row?.children) return;
    const selectedOption = Array.from(row.children).find((child) => child.getAttribute("key") === key);
    if(selectedOption) {
      selectedOption.classList.add('button-selected');
    }
  }

  clearSelectionStyleFromRow(rowIndex) {
    if(this.rowContainers[rowIndex]?.children?.length) {
      Array.from(this.rowContainers[rowIndex].children).forEach((child) => {
        child.classList.remove('button-selected');
      });
    }
  }

  getRowSelectionDependencyMap(rowIndex) {
    let traversedDependencyMap = dependencyMap;
    for(let i = 0; i < rowIndex; i++) {
      traversedDependencyMap = traversedDependencyMap[this.selections[i].key]
    }
    return traversedDependencyMap;
  }
  
  handleSubmit() {
    const url = new URL(window.location);
    rows.forEach((row, index) => {
      url.searchParams.set(row.submitKey, this.selections[index].submitValue);
    }, {});
    window.history.pushState({}, '', url);
    
    const dummyDiv = document.createElement("div");
    dummyDiv.className = 'dummyDiv';
    dummyDiv.style.display = 'none'
    document.body.appendChild(dummyDiv)

    const $dialogBox = this.shadowRoot.querySelector(".dialogBox");
    const $dialog = this.shadowRoot.querySelector(".dialog");
    
    const $closeButton = this.shadowRoot.querySelector(".closeButton");
    $closeButton.addEventListener("click", () => {
      $dialog.open = false;
      $dialogBox.innerHTML = "";
    });
    
    $dialog.addEventListener("closing", () => {
      $dialogBox.innerHTML = "";
    });


    hbspt.forms.create({
      target: ".dummyDiv",
      region: "na1",
      portalId: "8455127",
      formId: "6a1940d3-63fb-4a0f-beab-eece02194c58",
      onFormReady: function() {
        const form = dummyDiv;
        document.body.removeChild(dummyDiv)
        form.style.display = 'unset'
        $dialog.open = true;
        $dialogBox.appendChild(form);
      },
      css: '',
    });
  }
}

function buildImageBasePath(optionKeys) {
  return optionKeys.join("-");
}

function buildImageSrc(optionKeys, selectedImageIndex) {
  const path = buildImageBasePath(optionKeys) + "-" + selectedImageIndex;
  return path;
}

customElements.define("selection-gallery", SelectionGallery);
